import { develop } from "./develop";
import { local } from "./local";
import { production } from "./production";
import { stage } from "./stage";

const states = ["local", "develop", "stage", "master", "main"];
const state = process.env.STATE ?? states[0];

if (!states.includes(state))
  throw new Error(
    `STATE env can only be these values => ${states.join(", ")}, or you might not define it!`,
  );

export const env =
  state === "develop"
    ? develop
    : state === "stage"
      ? stage
      : state === "master" || state === "main"
        ? production
        : local;

export type * from "./types";
